<template>
  <v-container fluid class="main-cont">
    <v-dialog v-model="showTerms" max-width="800">
      <v-card>
        <v-card-title class="text-h6">
          Terms & Conditions
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text style="max-height: 60vh; overflow-y: auto;">
          <!-- TERMS CONTENT -->
          <div class="text-body-2">
            <div class="terms text-body-2">
              <h2>Terms and Conditions</h2>
              <!-- <p><strong>Last Updated:</strong> [Insert Date]</p> -->

              <h3>1. Overview</h3>
              <p>
                This platform ("Service") is operated by MoverAi Ltd ("Company"). By accessing or purchasing leads
                through this Service, you ("Mover", "User") agree to these Terms.
              </p>

              <h3>2. Nature of Service</h3>
              <ul>
                <li>The Company provides moving service leads to movers.</li>
                <li>
                  A lead consists of customer-provided information such as move details, inventory, and contact data.
                </li>
                <li>The Company does not guarantee accuracy, responsiveness, or conversion.</li>
              </ul>

              <h3>3. Lead Types</h3>
              <p><strong>Shared Leads:</strong></p>
              <ul>
                <li>Shared with up to 4 movers</li>
                <li>Non-exclusive access</li>
                <li>Lower price</li>
              </ul>

              <p><strong>Exclusive Leads:</strong></p>
              <ul>
                <li>Provided to one mover only</li>
                <li>Higher price</li>
                <li>Limited availability</li>
              </ul>

              <h3>4. Payments</h3>
              <ul>
                <li>All payments are processed securely via third-party providers (e.g., Stripe).</li>
                <li>Prices are displayed before purchase.</li>
                <li>By purchasing, you authorize the charge.</li>
              </ul>

              <h3>5. No Refunds Policy</h3>
              <p>
                All lead purchases are final and non-refundable, including:
              </p>
              <ul>
                <li>Non-responsive customers</li>
                <li>Incorrect or incomplete information</li>
                <li>Failure to secure the job</li>
              </ul>

              <h3>6. Introductory / Free Leads</h3>
              <ul>
                <li>The Company may provide free or discounted leads at its discretion.</li>
                <li>Limits may apply (e.g., first X leads).</li>
                <li>Abuse or manipulation may result in suspension.</li>
              </ul>

              <h3>7. User Obligations</h3>
              <ul>
                <li>Contact customers professionally and promptly</li>
                <li>Do not spam or harass customers</li>
                <li>Use leads only for legitimate moving services</li>
                <li>Do not resell or redistribute lead information</li>
              </ul>

              <h3>8. Prohibited Use</h3>
              <ul>
                <li>Using automated systems to scrape leads</li>
                <li>Sharing access links with unauthorized parties</li>
                <li>Misrepresenting your company</li>
                <li>Bypassing payment mechanisms</li>
              </ul>

              <h3>9. Account Termination</h3>
              <p>
                The Company reserves the right to suspend or terminate access at any time for misuse, abuse, or fraud.
              </p>

              <h3>10. Limitation of Liability</h3>
              <p>
                The Company is not liable for lost revenue, failed deals, or inaccurate data. All leads are provided
                "as-is".
              </p>

              <h3>11. Data Usage</h3>
              <p>
                Customer data must be used only for providing moving services and in compliance with applicable laws.
              </p>

              <h3>12. Modifications</h3>
              <p>
                These Terms may be updated at any time. Continued use of the Service constitutes acceptance of changes.
              </p>

              <h3>13. Contact</h3>
              <p>For questions, contact: <strong>support@movecost.ai</strong></p>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showTerms = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- LOADING -->
    <v-row justify="center" v-if="loading">
      <v-progress-circular indeterminate size="40" />
    </v-row>

    <!-- ERROR -->

    <!-- MAIN CARD -->
    <v-container class="py-6">
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8" xl="6">
          <v-card v-if="lead" class="pa-4 mx-auto">
            <!-- TITLE -->
            <v-row class="lead" d-flex align="center" justify="center">
              <v-card-title class="text-h6 ma-2 text-center w-100">
                {{ access.full_access ? "Unlocked" : "New" }} {{ freeLead }} Moving Lead from
                {{ formatDate(lead.lead_date) }} for {{ companyName }}
                {{ freeLeadsLeft }}
              </v-card-title>
              <br />

              <!-- <v-divider /> -->

              <!-- MOVE INFO -->
              <v-card-text class="mt-6">
                <div class="mb-4">
                  <h3>Move:</h3>
                  <br />
                  <span class="primary--text font-weight-bold ml-2">
                    {{ lead.from_city }}, {{ lead.from_state }}
                    →
                    {{ lead.to_city }}, {{ lead.to_state }}</span
                  >
                </div>

                <div v-if="lead.move_date" class="mb-4">
                  <h3>Date:</h3>
                  <br />
                  <span class="primary--text font-weight-bold ml-2"> {{ lead.move_date }}</span>
                  <br />
                </div>

                <!-- INVENTORY -->
                <div v-if="lead.inventory && lead.inventory.length" class="mb-4">
                  <h3 class="mb-4">Inventory (verified):</h3>
                  <!-- <v-list dense>
            <v-list-item v-for="(item, i) in lead.inventory" :key="i">
              <v-list-item-content> {{ item.qty }} × {{ item.item }} ({{ item.volume }} cf)</v-list-item-content>
            </v-list-item>
          </v-list> -->
                  <v-row>
                    <v-col v-for="(items, room) in groupedInventory" :key="room" class="mb-4">
                      <h4 class="ml-2">{{ room }}</h4>

                      <v-list dense>
                        <v-list-item v-for="(item, i) in items" :key="i">
                          <v-list-item-content>
                            <v-list-item-title> {{ item.qty }} × {{ item.item }} </v-list-item-title>

                            <v-list-item-subtitle v-if="item.volume"> {{ item.volume }} cu ft </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col></v-row
                  >
                </div>
                <h3>Total Volume:</h3>
                <br />
                <span class="primary--text font-weight-bold ml-2"> {{ totalVolume }} cf</span>
                <br />
                <!-- ESTIMATE -->
                <div v-if="lead.estimated_price" class="mb-4">
                  <br />
                  <h3>Estimated Cost Given to the Customer:</h3>
                  <br />
                  <span class="primary--text font-weight-bold ml-2">
                    {{ lead.estimated_price }}
                  </span>
                </div>
                <h3>Comments:</h3>
                <br />
                <span class="primary--text font-weight-bold ml-2">{{ lead.comments || "(not given)" }}</span>
                <br />
                <!-- <hr /> -->

                <!-- CONTACT -->
                <div class="mt-4">
                  <h3>Contact:</h3>
                  <br />

                  <div v-if="access.full_access">
                    <span>
                      <strong class="ml-2">Customer Name:</strong>
                      <span class="primary--text font-weight-bold"> {{ lead.customer_name }}</span
                      ><br />
                      <strong class="ml-2">Phone:</strong>
                      <span class="primary--text font-weight-bold"> {{ lead.phone }}</span
                      ><br />
                      <strong class="ml-2">Email:</strong>
                      <span class="primary--text font-weight-bold"> {{ lead.email }}</span
                      ><br
                    /></span>
                  </div>

                  <div v-else class="grey--text">
                    <strong class="ml-2">Customer Name:</strong>🔒 Locked<br />
                    <strong class="ml-2">Phone:</strong> 🔒 Locked<br />
                    <strong class="ml-2">Email:</strong> 🔒 Locked<br />
                  </div>
                </div>
              </v-card-text>
            </v-row>
            <v-divider />

            <v-card v-if="!access.full_access" class="pa-4" elevation="6">
              <div v-if="access.requires_payment" class="d-flex justify-center align-center mt-2 cc-icons">
                <i class="fa-brands fa-cc-visa mx-2"></i>
                <i class="fa-brands fa-cc-mastercard mx-2"></i>
                <i class="fa-brands fa-cc-amex mx-2"></i>
                <i class="fa-brands fa-cc-discover mx-2"></i>
              </div>
              <!-- CARD INPUT -->
              <v-text-field
                label="Card Holder Name"
                v-model="cardHolderName"
                :rules="[rules.required]"
                v-if="access.requires_payment"
              ></v-text-field>
              <div class="mb-4">
                <div id="card-element" class="stripe-card"></div>
              </div>

              <!-- ACTIONS -->
              <v-card-actions class="d-flex flex-column">
                <v-btn
                  v-if="access.can_unlock_free"
                  color="success"
                  block
                  class="mb-2"
                  :loading="unlocking"
                  @click="unlockFree"
                >
                  Unlock (Free)
                </v-btn>

                <v-btn
                  v-if="access.requires_payment && !lead.opened"
                  color="warning"
                  dark
                  block
                  class="mb-2"
                  :loading="paying"
                  @click="buyLead(true)"
                >
                  Buy Exclusive ({{ formatCurrency(exclusivePrice) }})
                </v-btn>

                <v-btn v-if="access.requires_payment" color="success" dark block :loading="paying" @click="buyLead">
                  Buy {{ !lead.opened ? "Shared" : "" }} ({{ formatCurrency(sharedPrice) }}). Max 4 movers per lead
                  (Guaranteed)
                </v-btn>
                <span class="caption mt-4">
                  By proceeding you agree to
                  <a href="#" @click.prevent="showTerms = true">Terms & Conditions</a>
                </span>
              </v-card-actions>
            </v-card>
            <v-alert v-if="error" type="error" dense>
              {{ error }}
            </v-alert>
            <v-alert v-if="success" type="success" dense>
              {{ success }}
            </v-alert>
            <!-- </v-col> -->
            <!-- </v-row> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import * as fun from "../plugins/common";
import { loadStripe } from "@stripe/stripe-js";
import "@fortawesome/fontawesome-free/css/all.css";
import axios from "axios";
export default {
  name: "LeadAccess",

  data() {
    return {
      loading: true,
      success: null,
      error: null,
      card: null,
      companyName: null,
      freeLead: null,
      freeLeadsLeft: null,
      lead: null,
      access: {},
      mover_email: null,
      totalVolume: 0,
      unlocking: false,
      freeLeads: false,
      paying: false,
      exclusivePrice: null,
      sharedPrice: null,
      haveExclusive: false,
      showPayment: false,
      stripe: null,
      clientSecret: null,
      showTerms: false,
      testCard: "4242424242424242",
      cardHolderName: "George Freed",
      amount: null,
      exclusive: false,
      rules: {
        required: value => !!value || "Required.",
        number: value => !isNaN(value) || "Must be a number."
      }
    };
  },

  async mounted() {
    const pKey =
      // "pk_live_51OsSpk04kpeqHnoBIRU3eJqiZJP8cMAQyomR8XFiPXhNsKSr6fcNQ6ahDtX763ZLpdcBk1R7RxsYZIoPAq2MneJ500DtYHznOu";
      "pk_test_51OsSpk04kpeqHnoBKHK3gLHaEOGgcYDQLQFksuSsgHAX9UrdIqIkNidSvlUsv6u1s2p3A1lVDZtl8J2lIsCEdCR800PTi9fqz2";
    this.stripe = await loadStripe(pKey);
    this.fetchLead();
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      this.errorMessage = "";
      this.success = "";
      // if (this.saveCard) {
      const { token, error } = await this.stripe.createToken(this.card, {
        name: this.cardHolderName
      });
      if (error) {
        this.error = error.message;
      } else {
        this.submitPayment(token);
      }
      // } else {
      //   this.setupCard();
      // }
    },

    async submitPayment(token) {
      this.paying = true;
      this.error = null;
      this.errorMessage = "";
      try {
        const response = await fetch(this.serverURL + "/charge_stripe_card", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            token: token.id,
            amount: this.amount,
            movecost: true,
            lead_id: this.lead.lead_id,
            // saveCard: this.saveCard,
            customerId: this.mover_email
            // priceId: this.priceId
          })
        });
        const data = await response.json();
        console.log("data", data);
        this.paying = false;
        if (data.error) {
          // this.error = data.error;
          this.error = data.error;
        } else {
          this.success = `Payment successful! ${
            this.exclusive ? "This lead is now fully yours" : "The lead is now unlocked"
          } `;
          this.access.full_access = true;
          var contact = data.contact;
          this.lead.customer_name = contact.customer_name;
          this.lead.phone = contact.phone;
          this.lead.email = contact.email;
          // this.lead = data.get("lead");
          // window.location.reload();
        }
      } catch (error) {
        this.loading = false;
        this.error = "Payment failed. Please try again.";
      }
    },
    async submitPayment_() {
      var that = this;
      const result = await this.stripe.confirmCardPayment(this.clientSecret, {
        payment_method: {
          card: that.card
        }
      });
      console.log("result", result);

      if (result.error) {
        alert(result.error.message);
        return;
      }

      if (result.paymentIntent.status === "succeeded") {
        // ✅ payment completed
        this.unlockLead(result.paymentIntent.id);
      }
    },
    unlockLead(payment_intent_id) {
      axios
        .post(
          this.serverURL + "/create_unlock_lead",
          {
            payment_intent_id: payment_intent_id
          },
          {}
        )
        .then(response => {
          window.location.reload();
        });
    },
    buyLead(exclusive) {
      this.amount = exclusive ? this.exclusivePrice : this.sharedPrice;
      this.exclusive = exclusive;
      this.handleSubmit();
      // axios
      //   .post(
      //     this.serverURL + "/create_payment_intent",
      //     {
      //       lead_id: this.lead.lead_id,
      //       mover_email: this.mover_email,
      //       amount: exclusive ? this.exclusivePrice : this.sharedPrice
      //     },
      //     {}
      //   )
      //   .then(response => {
      //     if (response.data.error) {
      //       this.error = response.data.error;
      //     } else {
      //       this.clientSecret = response.data.clientSecret;
      //       this.submitPayment();
      //     }
      //   });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    },
    formatDate(value) {
      return fun.formatDate(value);
    },

    fetchLead() {
      var that = this;
      try {
        const token = this.$route.params.token;

        axios.post(this.serverURL + "/get_lead_by_token", { token: token }, {}).then(response => {
          // console.log(response.data);
          // Assuming the API returns an array of crews

          that.lead = response.data.lead;
          that.exclusivePrice = that.lead.lead_price?.exclusive_price;
          that.sharedPrice = that.lead.lead_price?.shared_price;
          that.haveExclusive = !that.lead.opened;
          this.access = response.data.access;
          if (this.access.requires_payment) {
            this.showPay();
          }
          this.mover_email = response.data.mover_id;
          this.companyName = response.data.company_name;
          this.freeLeads = response.data.free_leads_left;
          this.freeLeadsLeft = this.freeLeads ? `(${this.freeLeads} free leads left)` : "";
          this.freeLead = this.freeLeads ? " FREE " : "";
          this.totalVolume = (this.lead.inventory || []).reduce((sum, item) => {
            return sum + item.volume;
          }, 0);
          if (this.lead.status == "unlocked") {
            this.access.full_access = true;
          } else {
            this.error = response.data.error;
          }
        });
      } catch (e) {
        this.error = "Invalid or expired link";
      } finally {
        this.loading = false;
      }
    },

    unlockFree() {
      this.unlocking = true;
      axios
        .post(this.serverURL + "/unlock_free", { lead_id: this.lead.lead_id, mover_email: this.mover_email }, {})
        .then(response => {
          // console.log(response.data);
          // Assuming the API returns an array of crews
          if (response.data.error) {
            this.error = response.data.error;
          } else {
            if (response.data.unlocked.success) {
              this.access.full_access = true;
              this.lead = response.data.lead;
              this.success = "Successfully Unlocked!";
            }
          }

          this.unlocking = false;
        });
    },

    showPay(exclusive) {
      this.showPayment = true;

      this.$nextTick(() => {
        const elements = this.stripe.elements();

        this.card = elements.create("card");
        this.card.mount("#card-element");
      });
    }
  },
  computed: {
    groupedInventory() {
      const grouped = {};

      (this.lead.inventory || []).forEach(i => {
        const room = i.room || "Other";

        if (!grouped[room]) {
          grouped[room] = [];
        }

        grouped[room].push(i);
      });

      return grouped;
    }
  }
};
</script>
<style scoped>
.cc-icons i {
  font-size: 22px; /* 👈 size */
  opacity: 0.9;
}

/* Brand colors */
.fa-cc-visa {
  color: #1a1f71;
}

.fa-cc-mastercard {
  color: #eb001b;
}

.fa-cc-amex {
  color: #2e77bb;
}

.fa-cc-discover {
  color: #ff6000;
}
.terms h2 {
  margin-bottom: 10px;
}

.terms h3 {
  margin-top: 16px;
  margin-bottom: 6px;
}

.terms ul {
  padding-left: 18px;
  margin-bottom: 10px;
}

.terms p {
  margin-bottom: 8px;
}
</style>
